// Company email whitelist for dashboard access
// Add your company employee emails here
export const COMPANY_EMAILS: string[] = [
    'thisisharish07@gmail.com',
    'manishmssahu53@gmail.com',
    'prkhrprshr@gmail.com',
    'yashviagrawal25@gmail.com'
];

// Function to check if an email is authorized
export const isAuthorizedEmail = (email: string | null): boolean => {
    if (!email) return false;

    // Convert to lowercase for case-insensitive comparison
    const normalizedEmail = email.toLowerCase();

    // Check if email is in the whitelist
    return COMPANY_EMAILS.some(authorizedEmail =>
        authorizedEmail.toLowerCase() === normalizedEmail
    );
};

// Function to get the domain from an email
export const getEmailDomain = (email: string): string => {
    const parts = email.split('@');
    return parts.length > 1 ? parts[1].toLowerCase() : '';
};

// Optional: Allow all emails from a specific domain
export const ALLOWED_DOMAINS: string[] = [
];

// Function to check if email domain is authorized
export const isAuthorizedDomain = (email: string | null): boolean => {
    if (!email) return false;

    const domain = getEmailDomain(email);
    return ALLOWED_DOMAINS.some(allowedDomain =>
        domain === allowedDomain.toLowerCase()
    );
};

// Main function to check if user has access
export const hasAccess = (email: string | null): boolean => {
    if (!email) return false;

    // Check both individual email and domain-based access
    return isAuthorizedEmail(email) || isAuthorizedDomain(email);
};
